import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

/** Existing PLAN_EXPORT-gated portable-copy mutation, exposed to the privacy route. */
export const takePortableExportMutation = api.portability.export.takeExport;

export type TakePortableExportResult = FunctionReturnType<typeof takePortableExportMutation>;
